module.exports = __webpack_public_path__ + "static/Julian0-c0c39febe5e3c005f6bcb6b2e23e032b.jpg";